"use strict";

/**
 * Color API网关封装模块
 *
 * 功能说明：
 * - 提供Color网关的统一请求封装
 * - 支持多环境配置（开发/测试/预发布/生产）
 * - 统一错误处理和登录跳转逻辑
 * - 支持灰度发布和API迁移
 *
 * 使用场景：
 * - 替代原有网关接口调用
 * - 支持接口白名单和灰度控制
 * - 提供标准化的请求参数格式
 */

import axios from "axios";
// 登陆方式：H5
export const LOGIN_TYPE = 2;
// color应用的appid
export const appId = 'interact-share-h5'
// 获取接入baseurl
const getBaseURL = () => {
    const env = process.env.NODE_ENV || 'production'; // 默认开发环境

    switch (env) {
        case 'development':  // 本地开发
            return '';
        case 'test':         // 测试环境
            return '//api.jdtest.net';
        case 'beta':      // 预发布环境
            return '//beta-api.m.jd.com';
        case 'production':   // 生产环境
            return '//api.m.jd.com';
        default:             // 兜底逻辑
            return '//api.m.jd.com';
    }
};

const baseURL = getBaseURL();
const serviceColor = axios.create({
    baseURL: baseURL,
    timeout: 10000,
    withCredentials: true
});

serviceColor.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
serviceColor.interceptors.response.use(
    response => {
      let res = response.data
    if (res.code == "604") {
      location.href =
        "//msc.jd.com/payPwd/loginpage/wcoo/toShortIndex?source=15&active=101&returnUrl=" +
        encodeURIComponent(location.href);
        return Promise.reject()
    } else if (res.code == "20001") {
        // 用户未登陆
      location.href =
        "//plogin.m.jd.com/user/login.action?appid=1029&returnurl=" +
        encodeURIComponent(location.href);
      return Promise.reject()
    } else if (res.code == "402020005") {
        // 活动已结束
      location.pathname += "/error";
      return Promise.reject()
    } else if (res.code != "200") {
      // Vue.prototype.$toast(res.data.message || res.data.msg)
      return Promise.reject(res);
    } else {
      return Promise.resolve(res.data);
    }
  },
  error => {
    // Do something with response error
    return Promise.reject(error);
  }
);
/**
 * Color网关标准请求方法
 * @param {string} functionId - 业务功能标识符
 * @param {object} param - 业务参数对象
 * @returns {Promise} - 返回axios请求Promise
 *
 * 功能：
 * - 自动构建Color网关标准请求参数
 * - 统一处理时间戳、登录类型等通用参数
 * - 支持业务参数序列化
 */
export const fetchColorGet = (functionId, param={}) => {
    let requestParams = {
        appid: appId,                    // Color应用标识
        functionId: functionId,          // 业务功能ID
        t: new Date().getTime(),         // 请求时间戳
        body: JSON.stringify(param),     // 业务参数JSON序列化
        loginType: LOGIN_TYPE,           // H5登录类型
        client: 'H5',                    // 客户端类型
        clientVersion: '10.2.23'         // 客户端版本
    }
    return serviceColor.get('/api', { params: requestParams }); // 统一API路径
};

/**
 * Color网关自定义请求方法
 * @param {object} param - 完整的请求参数对象
 * @returns {Promise} - 返回axios请求Promise
 *
 * 功能：
 * - 支持完全自定义的请求参数格式
 * - 适用于特殊业务场景或已预处理的参数
 * - 直接透传参数到Color网关
 */
export const fetchColorGetForCustom = (param={}) => {
    return serviceColor.get('/api', { params: param });
}
